var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapping01 = function SvgMapping01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mapping-01_svg2__a",
    x1: 8.46,
    x2: 195.94,
    y1: 193.12,
    y2: -1.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M59.3 176.67c7.74-.02 14.02-6.29 14.03-14.03v-39.3h53.33v40.83c0 6.9 5.6 12.5 12.5 12.5h17.5V190c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-33.33c0-1.84-1.49-3.33-3.33-3.33h-33.33c-1.84 0-3.33 1.49-3.33 3.33V170h-17.5c-3.21-.02-5.82-2.62-5.83-5.83v-40.83c1.84 0 3.33-1.49 3.33-3.33v-16.67h23.33v13.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33V83.34c0-1.84-1.49-3.33-3.33-3.33h-33.33c-1.84 0-3.33 1.49-3.33 3.33v13.33h-23.33V80c0-1.84-1.49-3.33-3.33-3.33v-40c0-3.68 2.98-6.67 6.67-6.67h16.67v13.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33V10c0-1.84-1.49-3.33-3.33-3.33H160c-1.84 0-3.33 1.49-3.33 3.33v13.33H140c-7.36 0-13.33 5.97-13.33 13.33v40H73.34v-39.2c.17-7.56-5.77-13.86-13.33-14.13h-20V10c0-1.84-1.49-3.33-3.33-3.33H3.33C1.49 6.67 0 8.16 0 10v33.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33V30h20c3.89.25 6.86 3.57 6.67 7.47v39.2c-1.84 0-3.33 1.49-3.33 3.33v16.67H40V83.34c0-1.84-1.49-3.33-3.33-3.33H3.33C1.49 80.01 0 81.5 0 83.34v33.33c0 1.84 1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33v-13.33h23.33v16.67c0 1.84 1.49 3.33 3.33 3.33v39.3c0 4.07-3.3 7.37-7.37 7.37H43.31v-13.33c0-1.84-1.49-3.33-3.33-3.33H6.67c-1.84 0-3.33 1.49-3.33 3.33v33.33c0 1.84 1.49 3.33 3.33 3.33H40c1.84 0 3.33-1.49 3.33-3.33v-13.33H59.3ZM163.33 160H190v26.67h-26.67zm3.34-73.33h26.67v26.67h-26.67zm-3.34-73.34H190V40h-26.67zM33.33 40H6.67V13.33h26.67V40Zm0 73.33H6.67V86.66h26.67v26.67Zm36.67-30h60v33.33H70zM36.67 186.67H10V160h26.67z",
    style: {
      fill: "url(#mapping-01_svg2__a)"
    }
  }));
};
export default SvgMapping01;